import React, {useState} from 'react';
import {Button, Modal} from 'antd';
import {getAgainHandler, isLoading} from '../../store/TableRedux/TableRedux';
import {toast} from 'react-toastify';
import {useDispatch, useSelector} from 'react-redux';
import Pallet from "../../http_request/Model/pallet/Pallet";


const CancelPallet = ({
                          rowData,
                          title = 'ابطال شناسه',
                      }) => {
    const loading = useSelector((state) => state.TableRedux.loading);


    const [checked, setChecked] = useState(false);
     const [open, setOpen] = useState(false);
    const dispatch = useDispatch();

    const handleShow = () => {

        setOpen(true);

    };


    const handleOk = () => {


        Pallet.request({
            beforeSend: () => {
                dispatch(isLoading(true));
            }, success: (result) => {
                setChecked(!checked)
                setOpen(false)
                toast.success(` شناسه  ${rowData?.palletId} ابطال شد`);
                dispatch(getAgainHandler());
                // todo check getAgainHandler
            }, error: (error) => {
                toast.error(error.data.message);

            }, final: () => {
                dispatch(isLoading(false));
            },


        }).CanclePallet(rowData?.palletId);


    };


    const handleCancel = () => {
        setOpen(false);
    };

    return (
        <>
            <Button onClick={handleShow} className='defBtn redBtn'>ابطال</Button>
            <Modal
                open={open}
                title={title}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={[
                    <Button className='defBtn redBtn' key='back' onClick={handleCancel}>
                        انصراف
                    </Button>,
                    <Button className='defBtn blueBtn' key='submit' type='primary' loading={loading} onClick={handleOk}>
                        ثبت
                    </Button>,

                ]}
            >
                <p>آیا از ابطال شناسه اطمینان دارید؟</p>
            </Modal>
        </>

    );
};

export default CancelPallet;